import { useCallback } from "react";
import { useCookies } from "react-cookie";

import { StaticValue } from "../seed/constants";

const useSetResumeIdCookie = () => {
	const staticValue = new StaticValue();
	const staticValues = staticValue.getDefaultValues();
	// Watch the real cookie name — `useCookies` only re-renders for the names it
	// is given, and `["resume"]` names a cookie that does not exist, so callers
	// reading the returned `cookie` saw a stale value after a write.
	const cookieName: string = staticValues.localStorageResumeId;
	const [cookie, setCookie, removeCookie] = useCookies([cookieName]);

	const setResumeIdCookie = useCallback(
		(resumeId: string) => {
			const expireDate = new Date();
			expireDate.setDate(expireDate.getDate() + 7);
			setCookie(cookieName, resumeId, {
				path: "/",
				expires: expireDate,
			});
		},
		[cookieName, setCookie],
	);

	// The pointer is written with `path: "/"`, so the removal has to name that same
	// path. Without it react-cookie targets the current directory instead and the
	// cookie survives everywhere below the root.
	const clearResumeIdCookie = useCallback(() => {
		removeCookie(cookieName, { path: "/" });
	}, [cookieName, removeCookie]);

	return { cookie, setResumeIdCookie, clearResumeIdCookie };
};

export default useSetResumeIdCookie;
